import styled from 'react-emotion'

const Pager = styled('div')(({ next }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: next && 0,
  left: !next && 0,
  width: '10%',
  cursor: next ? 'e-resize' : 'w-resize'
}))

export default Pager